const createList = (icon, text) => {
  return `
    <ul>
      <li><img src="/assets/images/${icon}.svg" alt="" /></li>
      <li><p>${text}</p></li>
    </ul>
  `;
};

const divForPlanId1 = `<div class="subpoint_list">
    ${createList("check", "Full access to design tools and features.")}
    ${createList(
      "warning",
      "Limited to 100 variations during the trial period."
    )}
  </div>`;
const divForPlanId2Or5 = `<div class="subpoint_list">
    ${createList("check", "Full access to design tools and features.")}
    ${createList(
      "warning",
      "Pay only for the actual number of Variations created."
    )}
    ${createList("warning", "Pay as you use.")}
    ${createList("warning", "Minimum 200 recharge.")}
  </div>`;
const divForPlanIdUnlimited = `<div class="subpoint_list">
    ${createList("check", "Full access to design tools and features.")}
    ${createList(
      "check",
      "Unlimited Creations can be created for a single user."
    )}
    ${createList(
      "check",
      "Experience the software with no commitment for 28 days."
    )}
  </div>`;
export const planLines = {
  1: divForPlanId1,
  2: divForPlanId2Or5,
  5: divForPlanId2Or5,
  6: divForPlanIdUnlimited,
  7: divForPlanIdUnlimited,
};
